<template>
  <el-table-column
    prop="is_billable"
    sortable="custom"
    label="Számlázandó"
    show-overflow-tooltip
    min-width="140"
  >
    <template slot-scope="scope">
      <el-tag
        v-if="scope.row.is_billable"
        size="small"
        type="success"
      >
        Igen
      </el-tag>
      <el-tag
        v-if="!scope.row.is_billable"
        size="small"
        type="danger"
      >
        Nem
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'is_billable',
};
</script>
